import { render, staticRenderFns } from "./twitter-input.vue?vue&type=template&id=195adc6e&scoped=true&"
import script from "./twitter-input.vue?vue&type=script&lang=js&"
export * from "./twitter-input.vue?vue&type=script&lang=js&"
import style0 from "./twitter-input.vue?vue&type=style&index=0&id=195adc6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195adc6e",
  null
  
)

export default component.exports